import React,{useState} from "react";
import { NavLink } from "react-router-dom";
import { Sidebar, Separator } from "./style";
import { EXPIRED_PREMIUM, FREE } from "../../../../constants/premiumState";
import FeatureDeniedModal from "../../../../containers/app/components/accessDeniedOrReminderModals/featureDeniedModal";

export const SideBar = props => {
  const [featureLimitModalShow, setShow] = useState(false);
  return (
      <React.Fragment>
        <FeatureDeniedModal
            status={featureLimitModalShow}
            title="دریافت فایل"
            description="شما یک ویژگی حرفه‌ای را پیدا کرده‌اید! امکان دریافت خروجی فایل و بسیاری امکانات دیگر در اشتراک حرفه‌ای مپسا در دسترس می‌باشد."
            handleShow={show => setShow(show)}
        />
        <Sidebar>
          <ul className="sidebar-list">
            {menuItems.map((item, key) => {
              if (item.separator) {
                return <Separator key={key} />;
              } else {
                if (
                    (item.isOwner !== undefined && !item.isOwner) ||
                    (item.needPremiumChecking &&
                        props.initData &&
                        props.initData.data &&
                        props.initData.data.data &&
                        props.initData.data.data.project &&
                        (props.initData.data.data.project.premium_state === FREE ||
                            props.initData.data.data.project.premium_state ===
                            EXPIRED_PREMIUM))
                ) {
                  return (
                      <a
                          onClick={item.needPremiumChecking ? ()=> setShow(true):() => false}
                          key={key}
                          href="#"
                          target={item.externalLink ? "_blank" : "_self"}
                          title={(item.needPremiumChecking) ? item.text : 'تنها مدیر پروژه مجاز به ورود به این قسمت می‌باشد.'}
                      >
                        <li className={item.needPremiumChecking?"":"sidebar-disabled-link"}>
                          <i className={`icon ${item.icon}`} />
                          <span className="list-item-text">{item.text}</span>
                          {item.needPremiumChecking && <i className=" premium icon mapsa-premium-plan"/>}
                          {item.externalLink && (
                              <div className="sidebar-badge">
                                <i className="external-link-icon icon mapsa-external-link" />
                              </div>
                          )}
                        </li>
                      </a>
                  );
                }
                else {
                  return (
                      <NavLink
                          key={key}
                          to={item.to}
                          target={item.externalLink ? "_blank" : "_self"}
                          activeClassName="list-item-active"
                          title={item.text}
                      >
                        <li>
                          <i className={`icon ${item.icon}`} />
                          <span className="list-item-text">{item.text}</span>
                          {item.externalLink && (
                              <div className="sidebar-badge">
                                <i className="external-link-icon icon mapsa-external-link" />
                              </div>
                          )}
                        </li>
                      </NavLink>
                  );
                }
              }
            })}
          </ul>
          <div className="sidebar-footer">
            <div>
              <NavLink title="راهنمای مپسا" to="//mapsa.ir/help" target="_blank">
                راهنما
              </NavLink>
              <span className="circle-separator" />
              <NavLink
                  title=" قوانین و مقررات"
                  to="//mapsa.ir/terms/"
                  target="_blank"
              >
                قوانین و مقررات
              </NavLink>
            </div>
            <div className="copyright">حقوق این وبسایت متعلق به مپسا میباشد.</div>
          </div>
        </Sidebar>
      </React.Fragment>
  );
};

const menuItems = [
  {
    to: "/user-account-setting",
    activeClassName: "list-item-active",
    text: "حساب کاربری",
    externalLink: false,
    icon: "mapsa-user-1"
  },
  {
    to: "/project-setting",
    activeClassName: "list-item-active",
    text: "تنظیمات پروژه",
    externalLink: false,
    icon: "mapsa-Project-2",
    isOwner:
      JSON.parse(localStorage.getItem("project_info")) &&
      JSON.parse(localStorage.getItem("project_info")).length !== 0 &&
      JSON.parse(localStorage.getItem("project_info"))["is_owner"]
  },
  {
    to: "/project-member-management",
    activeClassName: "list-item-active",
    text: "مدیریت اعضای پروژه",
    externalLink: false,
    icon: "mapsa-users-setting",
    isOwner:
      JSON.parse(localStorage.getItem("project_info")) &&
      JSON.parse(localStorage.getItem("project_info")).length !== 0 &&
      JSON.parse(localStorage.getItem("project_info"))["is_owner"]
  },
  {
    separator: true
  },
  {
    to: "/construction-component",
    activeClassName: "list-item-active",
    text: "منابع مصرفی",
    externalLink: false,
    icon: "mapsa-outline-layers"
  },
  {
    to: "/construction-phase",
    activeClassName: "list-item-active",
    text: "فعالیت‌ها",
    externalLink: false,
    icon: "mapsa-steps"
  },
  {
    to: "/contact",
    activeClassName: "list-item-active",
    text: "مخاطبین",
    externalLink: false,
    icon: "mapsa-phone-book"
  },
  {
    to: "/bank-account",
    activeClassName: "list-item-active",
    text: "حساب های بانکی",
    externalLink: false,
    icon: "mapsa-bank"
  },
  {
    to: "/wallet",
    activeClassName: "list-item-active",
    text: "صندوق",
    externalLink: false,
    icon: "mapsa-wallet"
  },
  {
    to: "/tools",
    activeClassName: "list-item-active",
    text: "ابزار و ماشین‌آلات",
    externalLink: false,
    icon: "mapsa-work"
  },
  {
    separator: true
  },
  {
    to: "/backup",
    activeClassName: "list-item-active",
    text: "تهیه نسخه پشتیبان",
    externalLink: false,
    icon: "mapsa-coin",
    needPremiumChecking: true
  },
  {
    to: "/files",
    activeClassName: "list-item-active",
    text: "آرشیو دانلود‌ها",
    externalLink: false,
    icon: "mapsa-inbox"
  }
];
